import { useCallback, useContext, useState } from 'react';
import { View } from '@shared/components/View';
import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

interface Props {
  fieldName: string;
  label: string;
  disabled: boolean;
  onChange(value: boolean): void;
}

export function MBCardInputBlockQuestionCheckbox({ fieldName, label, disabled, onChange }: Props) {
  const colors = useContext(ColorThemeContext);
  const { values } = useContext(CardFormContext);
  const value = values[fieldName];

  const [checked, setChecked] = useState<boolean>(!!value);

  const handleChange = useCallback(() => {
    setChecked(!checked);
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <View row marginBottom={2}>
      <MBTouchableOpacity disabled={disabled} onPress={handleChange}>
        {checked ? (
          <MBIconV2 name="check-filled" color={colors.accent} />
        ) : (
          <MBIconV2 name="check-task" color={colors.input.borderInactive} />
        )}
      </MBTouchableOpacity>
      <View paddingTop={1.25} flex paddingLeft={1}>
        <MBTextBody1 flex>{label}</MBTextBody1>
      </View>
    </View>
  );
}
